import React from 'react'
import styles from './BaseButton.module.css'

export const BaseButton = ({
    variant = 'primary',
    fullWidth = false,
    children,
    className = '',
    onClick,
    ...props
}) => {
    const variantClass = styles[`variant${variant.charAt(0).toUpperCase() + variant.slice(1)}`]

    const classes = [
        styles.baseButton,
        variantClass,
        fullWidth ? styles.fullWidth : '',
        className
    ].filter(Boolean).join(' ')

    const handleClick = (e) => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        if (onClick) {
            onClick(e)
        }
    }

    return (
        <button className={classes} onClick={handleClick} {...props}>
            {children}
        </button>
    )
}

export default BaseButton
